import { useEffect, useState } from "react"

export const useWindowWidth = () => {
    const MOBILE_WIDTH = 650;
    const TABLET_WIDTH = 1024;

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_WIDTH);
    const [isTablet, setIsTablet] = useState(
        window.innerWidth >= MOBILE_WIDTH && window.innerWidth < TABLET_WIDTH
    );
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= TABLET_WIDTH);

    useEffect(() => {
        const handleWindowResize = () => {
            setWindowWidth(window.innerWidth);
            setIsMobile(window.innerWidth < MOBILE_WIDTH);
            setIsTablet(
                window.innerWidth >= MOBILE_WIDTH && window.innerWidth < TABLET_WIDTH
            );
            setIsDesktop(window.innerWidth >= TABLET_WIDTH);
        };

        window.addEventListener('resize', handleWindowResize);
        return () => window.removeEventListener('resize', handleWindowResize);
    }, []);

    return [windowWidth, isMobile, isTablet, isDesktop];
};